import { downloadFile, downloadFileWithPresignedUrl, extractData, handleApiException, handleResponse } from "helpers/apiResponseHelper";
import { apiService } from "services/api.service";
import axios, { AxiosResponse } from "axios";
import { ChargingAgreement } from "models/charging/agreement";

async function getAgreements(customerId: number): Promise<ChargingAgreement[]> {
  return axios.get(`${apiService.getApiUrl()}/charging/agreements/customer/${customerId}`)
      .then(handleResponse).then(extractData).catch(handleApiException);
}

export interface ChargingAgreementAcceptOffer {
  startDate: string;
  email: string;
  phone: string;
  address: string;
  city?: string;
  zip?: string;
  county?: string;
}

async function acceptAgreementOffer(
  agreementId: number,
  customerId: number,
  request: ChargingAgreementAcceptOffer,
  contactPersonId: number
)  : Promise<AxiosResponse<ChargingAgreement>> {
  return axios.post(`${apiService.getApiUrl()}/charging/agreements/offer/${agreementId}/accept`, request, {
    params: {
      customerId, 
      contactPersonId
    }
  }).then(handleResponse).catch(handleApiException);
}

async function rejectAgreementOffer(agreementId: number, customerId: number, contactPersonId: number) {
  return axios.post(`${apiService.getApiUrl()}/charging/agreements/offer/${agreementId}/reject`, null, {
    params: {
      customerId,
      contactPersonId
    }
  }).then(handleResponse).catch(handleApiException);
}

async function getAgreementPdf(agreementId: number, customerId: number, filename?: string): Promise<AxiosResponse<string>> {        
  return axios.get(`${apiService.getApiUrl()}/charging/agreements/${agreementId}/file?customerId=${customerId}&downloadAs=${filename}`)
      .then(handleResponse).catch(handleApiException);
}

async function getAgreementPdfWithDownload(agreementId: number, customerId: number, filename: string): Promise<void> {    
  return getAgreementPdf(agreementId, customerId, filename)
      .then((res) => downloadFileWithPresignedUrl(res.data));
}

interface ChargingAgreementPreviewFileParams {
  customerId: number;
  startDate: string;
  email: string;
  phone: string;
  address: string;
}

async function getAgreementPreviewFile(chargingAgreementId: number, params: ChargingAgreementPreviewFileParams) : Promise<Blob>  {
  return axios.get(`${apiService.getApiUrl()}/charging/agreements/${chargingAgreementId}/preview`, {
      params: params,
      responseType: 'blob'
  })
  .then(handleResponse)
  .catch(handleApiException);
}

async function getAgreementPreviewFileWithDownload(chargingAgreementId: number, downloadAs: string, params: ChargingAgreementPreviewFileParams) {
  const url = `${apiService.getApiUrl()}/charging/agreements/${chargingAgreementId}/preview`;
  return getAgreementPreviewFile(chargingAgreementId, params).then((res) => downloadFile(downloadAs, res, url));
}

const ChargingAgreementService = {
  getAgreements,
  acceptAgreementOffer,
  rejectAgreementOffer,
  getAgreementPdf,
  getAgreementPdfWithDownload,
  getAgreementPreviewFile,
  getAgreementPreviewFileWithDownload
};

export default ChargingAgreementService;